module.exports = __webpack_public_path__ + "static/kevinTweedle-ce01d4392aad1433b2422ab3305d1df9.jpg";